import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { tap } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private loaderNotNeeded: string[] = [
  ];

  constructor(private loaderService: LoaderService,
              private translate: TranslateService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isLoaderNeeded(req.url)) {
      this.loaderService.addRequest();
    }

    req = req.clone({
      setHeaders: {
        'Accept-Language': this.translate.store.currentLang || 'hu'
      },
    });

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            if (this.isLoaderNeeded(event.url)) {
              this.loaderService.removeRequest();
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          if (this.isLoaderNeeded(err.url)) {
            this.loaderService.removeRequest();
          }
        }
      })
    );
  }

  private isLoaderNeeded(url: string | null): boolean {
    if (!url) {
      return false;
    }
    return !this.loaderNotNeeded.some((notNeededURL: string) => url.indexOf(notNeededURL) > -1);
  }

}
